export default {
    init() {
        console.log('blog');
    },

    finalize() {
        // fire after everything else on this page
    },
};




// WEBPACK FOOTER //
// ./scripts/routes/blog.js